"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReactStyleFromCssStyle = void 0;
/*
turn a kebab cased string into a camel cased one
 */
function kebabToCamelCase(s) {
    return s.replace(/(-\w)/g, function (m) { return m[1].toUpperCase(); });
}
function createReactStyleFromCssStyle(originalStyle, sheetDriver) {
    var camelCasedVariantStyle = {};
    Object.keys(originalStyle).forEach(function (value) {
        if (originalStyle[value] !== undefined) {
            var newVal = originalStyle[value];
            if (sheetDriver) {
                newVal = sheetDriver.evalDeclarationValue(newVal);
            }
            camelCasedVariantStyle[kebabToCamelCase(value)] = newVal;
        }
    });
    return camelCasedVariantStyle;
}
exports.createReactStyleFromCssStyle = createReactStyleFromCssStyle;
//# sourceMappingURL=style-conversions.js.map